/**
 * In-memory access JWT for the web SPA (TM-011).
 * Refresh lives in an HttpOnly cookie (`budgit_rt`); it must never be written
 * to localStorage. Legacy `token` / `refreshToken` keys are cleared on load
 * so a prior XSS loot pile is removed.
 */

const LEGACY_ACCESS_KEY = 'token';
const LEGACY_REFRESH_KEY = 'refreshToken';
/** Non-secret flag so we skip a refresh-token POST on anonymous marketing hits. */
const SESSION_HINT_KEY = 'budgit_has_session';

let accessToken = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = typeof token === 'string' && token ? token : null;
  if (accessToken) markSessionHint();
  return accessToken;
}

export function clearAccessToken() {
  accessToken = null;
}

export function markSessionHint() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(SESSION_HINT_KEY, '1');
  } catch (_) {
    // ignore
  }
}

export function clearSessionHint() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.removeItem(SESSION_HINT_KEY);
  } catch (_) {
    // ignore
  }
}

export function hasSessionHint() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    return window.localStorage.getItem(SESSION_HINT_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function clearLegacyTokenStorage() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.removeItem(LEGACY_ACCESS_KEY);
    window.localStorage.removeItem(LEGACY_REFRESH_KEY);
  } catch (_) {
    // private mode / blocked storage
  }
}

clearLegacyTokenStorage();
